import _ from 'lodash';

import AppDispatcher from '../dispatcher/AppDispatcher';
import { ActionTypes } from '../constants/AppConstants';

let oldHandler = null;
const WindowActions = {

    resize: _.throttle(() => {
        AppDispatcher.dispatch({
            actionType: ActionTypes.WINDOW_RESIZED
        });
    }, 500),

    startListeners () {
        oldHandler = window.onresize;
        window.onresize = this.resize;
    },

    stopListeners () {
        window.onresize = oldHandler;
    }

};


export default WindowActions;



// WEBPACK FOOTER //
// ./src/actions/WindowActions.js